import {useNavigate} from "react-router-dom";
import {RouteConstant} from "@/util/constant/RouteConstant.ts";
import {BaseModal} from "@/components/modal/BaseModal.tsx";

export default function SuccessReset() {
    const navigate = useNavigate();

    function gotoReset() {
        navigate(RouteConstant.auth.otp.path);
    }

    return (
        <BaseModal size={"sm"}>
            <div className="utility-page_component">
                <div className="utility-page_form-block w-form"
                     style={{
                         marginLeft: "auto",
                         marginRight: "auto",
                         marginTop: "200px",
                     }}
                >

                </div>
                <h3 style={{fontWeight: "500"}}>Success</h3>
                <div
                    style={{
                        fontWeight: "300",
                        width: "300px",
                        textAlign: "center",
                        marginLeft: "auto",
                        marginRight: "auto",

                        fontSize: "14px",
                    }}
                >
                    Email has been reset
                </div>
                <a
                    className="button w-button"
                    style={{width: "356px", padding: "10px", borderRadius: "10px"}}
                    onClick={() => gotoReset()}
                >
                    OK
                </a>
            </div>
        </BaseModal>
    );
}
